import axios from 'axios';

export default {
  search: function (request) {
    return axios.get('/api/poll/adminsearch', { params: request });
  },
  find: function (id) {
    return axios.get(`/api/poll/adminfind?id=${id}`);
  },
  update: function(data) {
    return axios.put(`/api/poll/${data.id}`, data);
  },
  updateQuestion: function(data) {
    return axios.put(`/api/poll/question/${data.id}`, data);
  }
}